import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../utils/api';
import Loader from '../../components/common/Loader';
import '../../styles/Forms.css';

const AddCategoryPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    isActive: true,
  });

  useEffect(() => {
    if (isEdit) {
      fetchCategory();
    }
  }, [id]);

  const fetchCategory = async () => {
    try {
      setLoading(true);
      const res = await api.getCategory(id);
      if (res.success && res.data) {
        const category = res.data;
        setFormData({
          name: category.name || '',
          description: category.description || '',
          isActive: category.isActive !== undefined ? category.isActive : true,
        });
      } else {
        toast.error('Category not found');
        navigate('/admin/categories');
      }
    } catch (error) {
      console.error('Error loading category:', error);
      toast.error('Error loading category details');
      navigate('/admin/categories');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error('Please enter category name');
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: formData.name.trim(),
        description: formData.description.trim() || undefined,
        isActive: formData.isActive,
      };

      let res;
      if (isEdit) {
        res = await api.updateCategory(id, payload);
      } else {
        res = await api.createCategory(payload);
      }

      if (res.success) {
        toast.success(isEdit ? 'Category updated successfully!' : 'Category created successfully!');
        navigate(-1);
      } else {
        toast.error(
          (isEdit ? 'Error updating category: ' : 'Error creating category: ') +
            (res.message || 'Unknown error')
        );
      }
    } catch (error) {
      console.error(isEdit ? 'Error updating category:' : 'Error creating category:', error);
      toast.error(
        (isEdit ? 'Error updating category: ' : 'Error creating category: ') +
          (error.message || 'Unknown error')
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading && isEdit) {
    return <Loader />;
  }

  return (
    <div className="add-category-page" style={{ padding: '16px', display: 'flex', justifyContent: 'center' }}>
      <div
        style={{
          background: 'white',
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
          maxWidth: '600px',
          width: '100%',
        }}
      >
        <h2 style={{ margin: '0 0 20px 0', fontSize: '18px', fontWeight: 600 }}>
          {isEdit ? 'Edit Category' : 'Add New Category'}
        </h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">
              Category Name <span style={{ color: '#e53e3e' }}>*</span>
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="4"
            />
          </div>

          <div style={{ marginBottom: '12px', display: 'flex', alignItems: 'center' }}>
            <input
              id="isActive"
              name="isActive"
              type="checkbox"
              checked={formData.isActive}
              onChange={handleInputChange}
              style={{ marginRight: '6px' }}
            />
            <label htmlFor="isActive" style={{ margin: 0, fontSize: '13px', color: '#4a5568' }}>
              Active
            </label>
          </div>

          <div style={{ display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' }}>
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn-secondary"
            >
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Saving...' : isEdit ? 'Update Category' : 'Create Category'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCategoryPage;

